import axios from 'axios';
import Config from '../../config.json';
import { convertToBase64 } from '../../tabs/Task/TaskUtil';
import { result } from 'lodash';
import { string } from 'mathjs';

/*
    request body formate:
    let payload = { data: {} }
*/

class AWSService{
    userInfo = JSON.parse(localStorage.getItem("userinfo"));
    URLCONST = {
        ATTACHMENTS:"attachments",
        ROLES:"roles",
        USERROLES:"userroles",
        TASKFLOWREMINDER:"taskflowreminder",
        MODULES:"Modules",
        TEAMS:"Teams_Manager",
        ACCESSCONTROL:"TaskAccessControl"
    }
    GetReminders(){
        return new Promise((resolve, reject) => {
            axios.get(Config.backend_aws_server_url+'reminder')
            .then((result) => {
                resolve(result);
            })
            .catch((err) => {
                reject(err);
            })
        })
    }
    getTaskReminder(messageId, module){
        return new Promise((resolve, reject) => {
            axios.get(Config.backend_aws_server_url+`getTaskReminder`, {params: {messageId, module}})
            .then((result) => {
                resolve(result);
            })
            .catch((err) => {
                reject(err);
            })
        })
    }
    convertToPolygon(bblNum){
        return new Promise((resolve, reject) => {
            axios.get(Config.backend_aws_server_url+`convertToPolygon`,{params: { bblNum } })
            .then((result) => {
                resolve(result);
            })
            .catch((err) => {
                reject(err);
            })
        })
    }
    
    // effectiveFirmPanel(polygon){
    //     return new Promise((resolve, reject) => {
    //         axios.get(Config.backend_aws_server_url+`effectiveFirmPanel`,{params: {polygon } })
    //         .then((result) => {
    //             resolve(result);
    //         })
    //         .catch((err) => {
    //             reject(err);
    //         })
    //     })
    // }
    AddReminders(payload){
        return new Promise((resolve, reject) => {
            axios.post(Config.backend_aws_server_url+'reminder',{type:"POST",data:{...payload}})
            .then((result) => {
                resolve(result);
            })
            .catch((err) => {
                reject(err);
            })
        })
    }
    UpdateReminders(payload,isMultiple){
        let config={
        }
        if(isMultiple){
            config["data"]=[...payload];
            config["isMultiple"]=isMultiple;
        }else{
            config["data"]={...payload};
        }
        return new Promise((resolve, reject) => {
            axios.put(Config.backend_aws_server_url+'reminder',config)
            .then((result) => {
                resolve(result);
            })
            .catch((err) => {
                reject(err);
            })
        })
    }
    DeleteReminders(payload,columnName){
        return new Promise((resolve, reject) => {
            axios.post(Config.backend_aws_server_url+'reminder',{type:"DELETE",data:[...payload],ColumnName:columnName})
            .then((result) => {
                resolve(result);
            })
            .catch((err) => {
                reject(err);
            })
        })
    }
    SaveHelperOps(obj,module,userId){
        return new Promise((resolve,reject)=>{
            let config = {
                type: 'POST',
                data: {
                  jsonData: obj,
                  userId : userId,
                  module : module
                },
            }
            axios.post(Config.backend_aws_server_url+'helperOps',{...config})
            .then((result) => {
                resolve(result);
            })
            .catch((err) => {
                reject(err);
            })
        })
    }
    GetHelperOps(){
        return new Promise((resolve, reject) => {
            axios.get(Config.backend_aws_server_url+'helperOps')
            .then((result) => {
                resolve(result);
            })
            .catch((err) => {
                reject(err);
            })
        })
    }
    DeleteHelperOps(userIds,conditions){
        return new Promise((resolve,reject)=>{
            let config = {
                type: 'DELETE',
                data: [...userIds],
                conditions: conditions,
            }
            axios.post(Config.backend_aws_server_url+'helperOps',{...config})
            .then((result) => {
                resolve(result);
            })
            .catch((err) => {
                reject(err);
            })
        })
    }

                 // Pipeline template APIs //
                 
       savePipelineInTemplate(data){ 
        return new Promise((resolve,reject)=>{ 
            axios.post(Config.backend_aws_server_url+'savePipelineInTemplate',{data:data}).then((result)=>{
                resolve(result.data);
            })
        })
    }
    updatePipelineInTemplate(data){ 
        return new Promise((resolve,reject)=>{ 
            axios.post(Config.backend_aws_server_url+'updatePipelineInTemplate',{data:data}).then((result)=>{
                resolve(result.data);
            })
        })
    }
    getAllPipelinesFromTemplate(){
        return new Promise(async (resolve,reject)=>{
           await axios.get(Config.backend_aws_server_url+'getAllPipelinesFromTemplate').then((result)=>{ 
                resolve(result)
            }).catch(err=>{
                reject(err)
            })
        })
    }
    deletePipelineFromTemplate(ROWID){
        return new Promise(async (resolve,reject)=>{
            await axios.delete(`${Config.backend_aws_server_url}deletePipelineFromTemplate?ROWID=${ROWID}`).then((result)=>{ 
                resolve(result)
            }).catch(err=>{
                reject(err)
            })
        })
    }
    //pipeline apis
    savePipeline(data){ 
        return new Promise((resolve,reject)=>{ 
            axios.post(Config.backend_aws_server_url+'savePipeline',{data:data}).then((result)=>{
                resolve(result.data);
            })
        })
    }
    updatePipeline(data){ 
        return new Promise((resolve,reject)=>{ 
            axios.post(Config.backend_aws_server_url+'updatePipeline',{data:data}).then((result)=>{
                resolve(result.data);
            })
        })
    }
    getAllPipelinesFromTable(){
        return new Promise(async (resolve,reject)=>{
           await axios.get(Config.backend_aws_server_url+'getAllPipelines').then((result)=>{ 
                resolve(result)
            }).catch(err=>{
                reject(err)
            })
        })
    }
    getAllPipelinesNames(){
        return new Promise(async (resolve,reject)=>{
           await axios.get(Config.backend_aws_server_url+'getAllPipelinesNames').then((result)=>{ 
                resolve(result)
            }).catch(err=>{
                reject(err)
            })
        })
    }
    deletePipeline(ROWID){
        return new Promise(async (resolve,reject)=>{
            await axios.delete(`${Config.backend_aws_server_url}deletePipeline?ROWID=${ROWID}`).then((result)=>{ 
                resolve(result)
            }).catch(err=>{
                reject(err)
            })
        })
    }
    getPipelineById(rowid){
        return new Promise(async (resolve,reject)=>{
            await axios.get(`${Config.backend_aws_server_url}getPipelineById?ROWID=${rowid}`).then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err);
            })
        })
    }

    // Tasks APIs //
    getAlltasks(){
        return new Promise(async (resolve,reject)=>{
            await axios.get(Config.backend_aws_server_url+'getAlltasks').then((result)=>{
                resolve(result.data)
            }).catch(err=>{
                reject(err)
            })
        })
    }
    saveTask(data){ 
        return new Promise(async (resolve,reject)=>{
            await axios.post(Config.backend_aws_server_url+'saveTask',{data:data}).then(result=>{
                resolve(result.data)
            }).catch(err=>{
                reject(err);
            })
        })
    }
    //three dots saving tasks

    savePipelineWithTask(data){ 
        return new Promise(async (resolve,reject)=>{
            await axios.post(Config.backend_aws_server_url+'savePipelineWithTask',{data:data}).then(result=>{
                resolve(result.data)
            }).catch(err=>{
                reject(err);
            })
        })
    }
    getTaskPresentStatusForDeal(deal,rowids){
        return new Promise(async (resolve,reject)=>{
            await axios.get(Config.backend_aws_server_url+`getTaskPresentStatusForDeal?DealName=${deal}&TaskTemplateIds=${rowids}`).then((result)=>{
                resolve(result.data)
            }).catch(err=>{
                reject(err)
            })
        })
    }
    getDependenciesPresentForDeal(deal,rowids){
        return new Promise(async (resolve,reject)=>{
            await axios.get(Config.backend_aws_server_url+`getDependenciesPresentForDeal?DealName=${deal}&TaskTemplateIds=${rowids}`).then((result)=>{
                resolve(result.data)
            }).catch(err=>{
                reject(err)
            })
        })
    }
    InsertCustomDependenciesWithInverse(dealname,data){
        return new Promise((resolve,reject)=>{
            axios.post(Config.backend_aws_server_url + `InsertCustomDependenciesWithInverse`,{DealName:dealname,data:data}).then(res=>{
                resolve(res)
            }).catch(err=>{
                reject(err)
            })
        })
    }
    getPipelineCloningSuggestions(dealName,rowids){
        return new Promise((resolve,reject)=>{
            axios.get(Config.backend_aws_server_url + `getPipelineCloningSuggestions?DealName=${dealName}&ROWID=${rowids}`).then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err)
            })
        })
    }
    //three dots saving tasks.
    updateTask(data){ 
        return new Promise(async (resolve,reject)=>{
            await axios.post(Config.backend_aws_server_url+'updateTask',{data:data}).then(result=>{
                resolve(result.data)
            }).catch(err=>{
                reject(err);
            })
        })
    }
    deleteTask(ROWID){
        return new Promise(async (resolve,reject)=>{
            await axios.delete(`${Config.backend_aws_server_url}deleteTask?ROWID=${ROWID}`).then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err);
            })
        })
    }

    reorderTaskListPosition(PipelineRowid, Position){
        return new Promise(async (resolve, reject)=>{
            await axios.put(`${Config.backend_aws_server_url}TaskListPosition/reorder`, {PipelineRowid:PipelineRowid, Position:Position}).then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err);
            })
        })
    }
    
    reorderTaskTemplatePosition(PipelineRowid, Position){
        return new Promise(async (resolve, reject)=>{
            await axios.put(`${Config.backend_aws_server_url}TaskTemplatePosition/reorder`, {PipelineRowid:PipelineRowid, Position:Position}).then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err);
            })
        })
    }
    // getSubTaskById(ROWID){
    //     return new Promise(async (resolve,reject)=>{
    //         await axios.get(`${Config.backend_aws_server_url}getSubTaskById?ROWID=${ROWID}`).then(res=>{
    //             resolve(res.data)
    //         }).catch(err=>{
    //             reject(err);
    //         })
    //     })
    // }
    getPipelineDataByDeal(DealName,findMilestone){
        return new Promise((resolve,reject)=>{
            axios.get(`${Config.backend_aws_server_url}getPipelineDataByDeal?DealName='${DealName}'${findMilestone?'&findMilestone="true"':''}`).then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err);
            })
        })
    }
   
    getAllPipeline(dealNames){
        return new Promise((resolve,reject)=>{
            axios.get(Config.backend_aws_server_url+`getPipelineWithRelatedData?dealNames=${dealNames}`).then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err);
            })
        })
    }
    getPipelineTemplateNames(flag){
        let query = flag?`getPipelineTemplateNames?flag=${flag}`:'getPipelineTemplateNames';
        return new Promise((resolve,reject)=>{
            axios.get(Config.backend_aws_server_url+query).then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err);
            })
        })
    }
    fetchTaskTimeTracker(){
        return new Promise((resolve,reject)=>{
            axios.get(Config.backend_aws_server_url+'fetchTaskTimeTracker').then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err);
            })
        })
    }
    getPipelineTemplateById(rowid){
        return new Promise(async (resolve,reject)=>{
            await axios.get(`${Config.backend_aws_server_url}getPipelineTemplateById?ROWID=${rowid}`).then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err);
            })
        })
    }
    //Activitys APIs
    getAllActivityByModule(sourceId,activityType,selectedFilter,pageSize,order,search){
        return new Promise(async (resolve,reject)=>{ 
        await axios.get(`${Config.backend_aws_server_url}getAllActivityByModule?sourceId=${sourceId}&activityType=${activityType}&selectedFilter=${selectedFilter}&pagesize=${pageSize}&Sort=${order}&SearchText=${search}`).then(res=>{
            resolve(res.data);
        }).catch(err=>{
            reject(err);
        })
        })
    }
    getAllActivityByDeal(dealName,activityType,selectedFilter,pageSize,order,search){
        return new Promise(async (resolve,reject)=>{ 
            await axios.get(`${Config.backend_aws_server_url}getAllActivityByDeal?dealName=${dealName}&activityType=${activityType}&selectedFilter=${selectedFilter}&pagesize=${pageSize}&Sort=${order}&SearchText=${search}`).then(res=>{
                resolve(res.data);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    getAllActivityByFilter(sourceId,activityType,selectedTypes){
        return new Promise(async (resolve,reject)=>{ 
        await axios.get(`${Config.backend_aws_server_url}getAllActivityByFilter?sourceId=${sourceId}&activityType=${activityType}&selectedTypes=${selectedTypes}`).then(res=>{
            resolve(res.data);
        }).catch(err=>{
            reject(err);
        })
        })
    }
    getAllPipelineTemplateData(ROWID){
        return new Promise(async (resolve,reject)=>{ 
        await axios.get(`${Config.backend_aws_server_url}getPipelineWithRelatedDataByTemplateId?ROWID=${ROWID}`).then(res=>{
            resolve(res.data[0]);
        }).catch(err=>{
            reject(err);
        })
        })
    }
    getPipelineTemplatesData(){//to get all the data as tasks and subtasks related to pipeline template.
        return new Promise(async (resolve,reject)=>{ 
        await axios.get(`${Config.backend_aws_server_url}getPipelineTemplatesData`).then(res=>{
            resolve(res.data);
        }).catch(err=>{
            reject(err);
        })
        }) 
    }
    createSubtask(data){
        return new Promise(async (resolve,reject)=>{
            await axios.post(`${Config.backend_aws_server_url}createSubtask`,{data:data}).then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err);
            })
        })
    }
    updateSubtask(data){
        return new Promise(async (resolve,reject)=>{
            await axios.put(`${Config.backend_aws_server_url}updateSubtask`,{data:data}).then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err);
            })
        })
    }
    deleteSubtask(ROWID){
        return new Promise(async (resolve,reject)=>{
            await axios.delete(`${Config.backend_aws_server_url}deleteSubtask?ROWID=${ROWID}`).then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err);
            })
        })
    }
    getTaskSubtasksNameWithIds(){
        return new Promise(async (resolve,reject)=>{
            await axios.get(`${Config.backend_aws_server_url}getTaskSubtasksNameWithIds`).then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err);
            })
        })
    }
    getAllTaskFlowsNames(){
        return new Promise(async (resolve,reject)=>{
            await axios.get(`${Config.backend_aws_server_url}getAllTaskFlowsNames`).then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err);
            })
        })
    }
    // task and subtask template api
    updateSubtaskInTemplate(data){
        return new Promise(async (resolve,reject)=>{
            await axios.put(`${Config.backend_aws_server_url}updateSubtaskInTemplate`,{data:data}).then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err);
            })
        })
    }
    deleteSubtaskInTemplate(ROWID){
        return new Promise(async (resolve,reject)=>{
            await axios.delete(`${Config.backend_aws_server_url}deleteSubtaskInTemplate?ROWID=${ROWID}`).then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err);
            })
        })
    }
    createSubtaskInTemplate(data){
        return new Promise(async (resolve,reject)=>{
            await axios.post(`${Config.backend_aws_server_url}createSubtaskInTemplate`,{data:data}).then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err);
            })
        })
    }
    getSubTaskByIdFromTemplate(ROWID){
        return new Promise(async (resolve,reject)=>{
            await axios.get(`${Config.backend_aws_server_url}getSubTaskByIdFromTemplate?ROWID=${ROWID}`).then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err);
            })
        })
    }
    getTaskByIdFromTemplate(ROWID){ // gets the task by id and all the related subtasks to it from template.
        return new Promise(async (resolve,reject)=>{
            await axios.get(`${Config.backend_aws_server_url}getTaskByIdFromTemplate?ROWID=${ROWID}`).then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err);
            })
        })
    }
    getTaskById(ROWID){ // gets the task by id and all the related subtasks to it from template.
        return new Promise(async (resolve,reject)=>{
            await axios.get(`${Config.backend_aws_server_url}getTaskById?ROWID=${ROWID}`).then(res=>{
                  
                resolve(res.data)
            }).catch(err=>{
                reject(err);
            })
        })
    }
    getSubTaskById(ROWID){ // gets the task by id and all the related subtasks to it from template.
        return new Promise(async (resolve,reject)=>{
            await axios.get(`${Config.backend_aws_server_url}getSubTaskById?ROWID=${ROWID}`).then(res=>{
                if (res.data && res.data[0]) {
                    // Add the extra key `SubTaskROWID` with the value of `ROWID`
                    res.data[0][0].SubTaskROWID = ROWID;
                  }
                resolve(res.data[0])
            }).catch(err=>{
                reject(err);
            })
        })
    }
    deleteTaskInTemplate(ROWID){
        return new Promise(async (resolve,reject)=>{
            await axios.delete(`${Config.backend_aws_server_url}deleteTaskInTemplate?ROWID=${ROWID}`).then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err);
            })
        })
    }
    updateTaskInTemplate(data){
        return new Promise(async (resolve,reject)=>{
            await axios.put(`${Config.backend_aws_server_url}updateTaskInTemplate`,{data:data}).then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err);
            })
        })
    }
    getAlltasksFromTemplate(){
        return new Promise(async (resolve,reject)=>{
            await axios.get(`${Config.backend_aws_server_url}getAlltasksFromTemplate`).then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err);
            })
        })
    }
    saveTaskInTemplate(data){
        return new Promise(async (resolve,reject)=>{
            await axios.post(`${Config.backend_aws_server_url}saveTaskInTemplate`,{data:data}).then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err);
            })
        })
    }
    createActivity(data){
        return new Promise((resolve,reject)=>{
            axios.post(`${Config.backend_aws_server_url}createActivity`,{data:data}).then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err);
            })
        })
    }
    deleteActivityByRowId(ROWID){
        return new Promise(async (resolve,reject)=>{
            await axios.delete(`${Config.backend_aws_server_url}deleteActivityByRowId?ROWID=${ROWID}`).then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err);
            })
        })
    }
    updateActivityByRowId(data){
        return new Promise(async (resolve,reject)=>{
            await axios.put(`${Config.backend_aws_server_url}updateActivityByRowId`,{data:data}).then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err);
            })
        })
    }
    // Task Flow APIs
    createTaskFlow(data){
        return new Promise(async (resolve,reject)=>{
            await axios.post(`${Config.backend_aws_server_url}createTaskFlow`,{data:data}).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    updateTaskFlow(data){
        return new Promise(async (resolve,reject)=>{
            await axios.put(`${Config.backend_aws_server_url}updateTaskFlow`,{data:data}).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    modifyTasksByFlowChange(data){
        return new Promise(async (resolve,reject)=>{
            await axios.post(`${Config.backend_aws_server_url}modifyTasks`,{data:data}).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    deleteTaskFlow(ROWID){
        return new Promise(async (resolve,reject)=>{
            await axios.delete(`${Config.backend_aws_server_url}deleteTaskFlow?ROWID=${ROWID}`).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    getTaskFlowById(ROWID){
        return new Promise(async (resolve,reject)=>{
            await axios.get(`${Config.backend_aws_server_url}getTaskFlowById?ROWID=${ROWID}`).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    getAllTaskFlows(){
        return new Promise(async (resolve,reject)=>{
            await axios.get(`${Config.backend_aws_server_url}getAllTaskFlows`).then(res=>{
                resolve(res.data);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    getNameAndIdOfTaskFlows(){
        return new Promise(async (resolve,reject)=>{
            await axios.get(`${Config.backend_aws_server_url}getNameAndIdOfTaskFlows`).then(res=>{
                resolve(res.data);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    //Comment table APIs
    getCommentsByTaskIdAndType(ROWID,Type){
        return new Promise(async (resolve,reject)=>{
            await axios.get(`${Config.backend_aws_server_url}getCommentsByTaskIdAndType?ROWID=${ROWID}&type=${Type}`).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    addComment(data){
        return new Promise(async (resolve,reject)=>{
            await axios.post(`${Config.backend_aws_server_url}addComment`,{data:data}).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    updateComment(data){
        return new Promise(async (resolve,reject)=>{
            await axios.put(`${Config.backend_aws_server_url}updateComment`,{data:data}).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    getTimelinesForTasks(ROWID){
        return new Promise(async (resolve,reject)=>{
            await axios.get(`${Config.backend_aws_server_url}statustimeline/getTimelinesForTasks?ROWID=${ROWID}`).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    getActivitiesRelatedToDeal(DealName){ 
        console.log("Dealname:-",DealName)
        return new Promise(async (resolve,reject)=>{
            await axios.get(`${Config.backend_aws_server_url}getActivitiesRelatedToDeal`,{params: { DealName }}).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    addReaction(reactionText, rowId){
        return new Promise(async (resolve,reject)=>{
            await axios.post(`${Config.backend_aws_server_url}addReactionToComment`,{reactionText, rowId}).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    deleteComment(ROWID){
        return new Promise(async (resolve,reject)=>{
            await axios.delete(`${Config.backend_aws_server_url}deleteComment?ROWID=${ROWID}`).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    updateComment(data){
        return new Promise(async (resolve,reject)=>{
            await axios.put(`${Config.backend_aws_server_url}updateComment`,{data:data}).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    getAllComments(){
        return new Promise(async (resolve,reject)=>{
            await axios.get(`${Config.backend_aws_server_url}getAllComments`).then(res=>{
                resolve(res.data[0]);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    getRolesByProjectId(projectId){
        return new Promise(async (resolve,reject)=>{
            await axios.get(`${Config.backend_aws_server_url}userroles/getByAccount?ProjectId=${projectId}`).then(res=>{
                resolve(res.data[0]);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    //Dependency APIs
    getDependecyByTaskId(type,ROWID){
        return new Promise(async (resolve,reject)=>{
            await axios.get(`${Config.backend_aws_server_url}getDependecyByTaskId?STaskType=${type}&ROWID=${ROWID}`).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    updateDependency(data){
        return new Promise(async (resolve,reject)=>{
            await axios.put(`${Config.backend_aws_server_url}updateDependency`,{data:data}).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    updateDependencyReverse(data){
        return new Promise(async (resolve,reject)=>{
            await axios.put(`${Config.backend_aws_server_url}updateDependencyReverse`,{data:data}).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    createDependency(data){
        return new Promise(async (resolve,reject)=>{
            await axios.post(`${Config.backend_aws_server_url}createDependency`,{data:data}).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    getOnlyTasks(){
        return new Promise(async (resolve,reject)=>{
            await axios.get(Config.backend_aws_server_url+'getOnlyTasks').then((result)=>{
                resolve(result.data)
            }).catch(err=>{
                reject(err)
            })
        })
    }
    deleteDependency(sourceId,sourceType,id,type,sourceStatus,targetStatus){
        return new Promise(async (resolve,reject)=>{
            await axios.delete(`${Config.backend_aws_server_url}deleteDependency?sourceId=${sourceId}&sourceType=${sourceType}&targetId=${id}&targetType=${type}&SourceDependencyStatus=${sourceStatus}&TargetDependencyStatus=${targetStatus}`).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    getAllDependencies(){
        return new Promise(async (resolve,reject)=>{
            await axios.get(`${Config.backend_aws_server_url}getAllDependencies`).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            })
        })
    }
      //time tracker APIs
      getAllTimeRecords(){
        return new Promise( async (resolve,reject)=>{
            await axios.get(`${Config.backend_aws_server_url}getAllTimeRecords`).then(res=>{
                resolve(res);
            }).catch(er=>{
                reject(er);
            })
        })
    }
    createTimeEntry(data){
        return new Promise( async (resolve,reject)=>{
            await axios.post(`${Config.backend_aws_server_url}createTimeEntry`,{data:data}).then(res=>{
                resolve(res);
            }).catch(er=>{
                reject(er);
            })
        })
    }
    updateTimeEntry(data){
        return new Promise( async (resolve,reject)=>{
            await axios.put(`${Config.backend_aws_server_url}updateTimeEntry`,{data:data}).then(res=>{
                resolve(res);
            }).catch(er=>{
                reject(er);
            })
        })
    }
    getTimeEntryById(ROWID,TaskROWID,TaskType){
        return new Promise( async (resolve,reject)=>{
            await axios.get(`${Config.backend_aws_server_url}getTimeEntryByID?ROWID=${ROWID}&TaskROWID=${TaskROWID}&TaskType=${TaskType}`).then(res=>{
                resolve(res);
            }).catch(er=>{
                reject(er);
            })
        })
    }
    getTimeEntryByTime(timeString,ID,Type,nextTime){
        return new Promise( async (resolve,reject)=>{
            await axios.get(`${Config.backend_aws_server_url}getTimeEntryByTime?UTCTimeString=${timeString}&taskId=${ID}&taskType=${Type}&nextTime=${nextTime}`).then(res=>{
                resolve(res);
            }).catch(er=>{
                reject(er);
            })
        })
    }
    getTimeRecordsByTask(TaskId,TaskType){
        return new Promise( async (resolve,reject)=>{
            await axios.get(`${Config.backend_aws_server_url}getTimeRecordsByTask?TaskROWID=${TaskId}&TaskType=${TaskType}`).then(res=>{
                resolve(res);
            }).catch(er=>{
                reject(er);
            })
        })
    }
    deleteTimeTrackRecord(ROWID){
        return new Promise( async (resolve,reject)=>{
            await axios.delete(`${Config.backend_aws_server_url}deleteTimeTrackRecord?ROWID=${ROWID}`).then(res=>{
                resolve(res);
            }).catch(er=>{
                reject(er);
            })
        })
    }
    //dependency template table APIs
    getTempDependecyByTaskId(type,ROWID){
        return new Promise(async (resolve,reject)=>{
            await axios.get(`${Config.backend_aws_server_url}getTempDependecyByTaskId?STaskType=${type}&ROWID=${ROWID}`).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    updateTempDependency(data){
        return new Promise(async (resolve,reject)=>{
            await axios.put(`${Config.backend_aws_server_url}updateTempDependency`,{data:data}).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    updateTempDependencyReverse(data){
        return new Promise(async (resolve,reject)=>{
            await axios.put(`${Config.backend_aws_server_url}updateTempDependencyReverse`,{data:data}).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    createTempDependency(data){
        return new Promise(async (resolve,reject)=>{
            await axios.post(`${Config.backend_aws_server_url}createTempDependency`,{data:data}).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            })
        })
    } 
    deleteTempDependency(sourceId,sourceType,id,type,sourceStatus,targetStatus){
        return new Promise(async (resolve,reject)=>{
            await axios.delete(`${Config.backend_aws_server_url}deleteTempDependency?sourceId=${sourceId}&sourceType=${sourceType}&targetId=${id}&targetType=${type}&SourceDependencyStatus=${sourceStatus}&TargetDependencyStatus=${targetStatus}`).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    getAllTempDependencies(){
        return new Promise(async (resolve,reject)=>{
            await axios.get(`${Config.backend_aws_server_url}getAllTempDependencies`).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    updateAssignee(name,row,column,tablename){
        return new Promise(async (resolve,reject)=>{
            await axios.put(`${Config.backend_aws_server_url}updateAssignee`,{data:name,ROWIds:row,ColumnName:column,name:tablename}).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    getCriteriaFields(){
        return new Promise(async (resolve,reject)=>{
            await axios.get(`${Config.backend_aws_server_url}getCriteriaFields`).then(res=>{ 
                resolve(res);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    getSubTaskBySubTaskIdFromTemplate(ROWID){  // gets subtask and related task to it from template.
        return new Promise(async (resolve,reject)=>{
            await axios.get(`${Config.backend_aws_server_url}getSubTaskBySubTaskIdFromTemplate?ROWID=${ROWID}`).then(res=>{
                resolve(res.data[0])
            }).catch(err=>{
                reject(err);
            })
        })
    }
    getSubTaskBySubTaskId(ROWID){  
        return new Promise(async (resolve,reject)=>{
            await axios.get(`${Config.backend_aws_server_url}getSubTaskBySubTaskId?ROWID=${ROWID}`).then(res=>{
                resolve(res.data[0])
            }).catch(err=>{
                reject(err);
            })
        })
    }
    getTaskFlowStatusDependancies(status,id){  
        return new Promise(async (resolve,reject)=>{
            await axios.get(`${Config.backend_aws_server_url}getTaskFlowStatusDependancies?status=${status}&flowid=${id}`).then(res=>{
                resolve(res.data[0])
            }).catch(err=>{
                reject(err);
            })
        })
    }
    fetchNodeDependancies(TaskFlowId,TaskStatus){  
        return new Promise(async (resolve,reject)=>{
            await axios.post(`${Config.backend_aws_server_url}getNodeDependancies`,
                {TaskFlowId:TaskFlowId,TaskStatus:TaskStatus}
            ).then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err);
            })
        })
    }
    updateIsResolvedInDependency(data){
        return new Promise(async (resolve,reject)=>{
            await axios.put(`${Config.backend_aws_server_url}updateIsResolvedInDependency`,{data:data}).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    reopenResolvedDependency(data){
        return new Promise(async (resolve,reject)=>{
            await axios.put(`${Config.backend_aws_server_url}reopenResolvedDependency`,{data:data}).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    createTimeline(data){
        return new Promise(async (resolve,reject)=>{
            await axios.post(`${Config.backend_aws_server_url}statustimeline/createTimelines`,{data:data}).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    getAllTimeline(){
        return new Promise(async (resolve,reject)=>{
            await axios.get(`${Config.backend_aws_server_url}statustimeline/getTimelines`).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    getAllTimelineBYIDANDTYPE(ROWID,type,fetchTransitions){
        return new Promise(async (resolve,reject)=>{
            await axios.get(`${Config.backend_aws_server_url}statustimeline/getTimelineByTaskIDAndType?ROWID=${ROWID}&Type=${type}${fetchTransitions ? '&fetchTransitions=true':''}`).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    getChecklistByTaskIDandType(id,type){
        return new Promise(async (resolve,reject)=>{
            await axios.get(`${Config.backend_aws_server_url}checkList/getChecklistByTaskIDandType?ROWID=${id}&TaskType=${type}`).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    createTaskChecklist(data){
        return new Promise(async (resolve,reject)=>{
            await axios.post(`${Config.backend_aws_server_url}checkList/createTaskChecklist`,{data:data}).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    updateTaskChecklist(data){
        return new Promise(async (resolve,reject)=>{
            await axios.put(`${Config.backend_aws_server_url}checkList/updateTaskChecklist`,{data:data}).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    deleteTaskChecklist(ROWID){
        return new Promise(async (resolve,reject)=>{
            await axios.delete(`${Config.backend_aws_server_url}checkList/deleteTaskChecklist?ROWID=${ROWID}`).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    getAllTemplateDependencies(){
        return new Promise(async (resolve,reject)=>{
            await axios.get(`${Config.backend_aws_server_url}getAllTempDependencies`).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    getAllDependecy(){
        return new Promise(async (resolve,reject)=>{
            await axios.get(`${Config.backend_aws_server_url}getAllDependecy`).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    getAllTimeRecordsWithDash(){
        return new Promise( async (resolve,reject)=>{
            await axios.get(`${Config.backend_aws_server_url}getAllTimeRecordsWithDash`).then(res=>{
                resolve(res);
            }).catch(er=>{
                reject(er);
            })
        })
    }
    //relative paths table 
    saveRelativePath(data){
        return new Promise( async (resolve,reject)=>{
            await axios.post(`${Config.backend_aws_server_url}saveRelativePath`,{data:data}).then(res=>{
                resolve(res);
            }).catch(er=>{
                reject(er);
            })
        })
    }
    getRelativePath(name,module){
        return new Promise( async (resolve,reject)=>{
            await axios.get(`${Config.backend_aws_server_url}getRelativePath?DealName=${name}&Module=${module}`).then(res=>{
                resolve(res);
            }).catch(er=>{
                reject(er);
            })
        })
    }
    //workdrive api
    fetchWorkdriveFolderById = (parentFolderId,accessToken)=>{
        return new Promise((resolve, reject) => {
            let config = {
                Type: "Get",
                url: "https://www.zohoapis.com/workdrive/api/v1/files/" + parentFolderId + "/files",
                method: "GET",
                headers: {
                    'Authorization': accessToken
                }
            };
            axios.post(Config.backend_aws_server_url + "zoho/workdrive", { config: config })
            .then(async function (response) {
                resolve(response);
            }).catch(err=>{
                reject(err)
            })
        })
    }

    getAllBugReport(email){
        return new Promise((resolve, reject) => {
            axios.get(Config.backend_aws_server_url+ `ReportBug/All?email=${email}`).then((result)=>{
              resolve(result);  
            }).catch((err) => {
                reject(err);
            })
        })
    }
    createBugReport(data){
    return new Promise((resolve, reject) => {
        axios.post(
            Config.backend_aws_server_url + `ReportBug`,
            data
        ).then((result) => {
            resolve(result);
        }).catch((err) => {
            reject(err);
        });
    });
    }
    getBugActivity(ROWID){
        return new Promise((resolve, reject) => {
            axios.get(Config.backend_aws_server_url+ `ReportBug/getActivity?ROWID=${ROWID}`).then((result)=>{
              resolve(result);  
            }).catch((err) => {
                reject(err);
            })
        })
    }
    createBugActivity(data){
    return new Promise((resolve, reject) => {
        axios.post(
            Config.backend_aws_server_url + `ReportBug/createActivity`,
            data
        ).then((result) => {
            resolve(result);
        }).catch((err) => {
            reject(err);
        });
    });
    }
    getBugComments(ROWID){
        return new Promise((resolve, reject) => {
            axios.get(Config.backend_aws_server_url+ `ReportBug/getComments?ROWID=${ROWID}`).then((result)=>{
              resolve(result);  
            }).catch((err) => {
                reject(err);
            })
        })
    }
    markCommentsRead(ROWID, OwnerName){
        return new Promise((resolve, reject) => {
            axios.put(Config.backend_aws_server_url+ `ReportBug/markCommentsRead?ROWID=${ROWID}&OwnerName=${OwnerName}`).then((result)=>{
              resolve(result);  
            }).catch((err) => {
                reject(err);
            })
        })
    }
    getBugCommentsUnreadCount(OwnerName){
        return new Promise((resolve, reject) => {
            axios.get(Config.backend_aws_server_url+ `ReportBug/getBugCommentsUnreadCount?OwnerName=${OwnerName}`).then((result)=>{
              resolve(result);  
            }).catch((err) => {
                reject(err);
            })
        })
    }
    createBugComment(data){
    return new Promise((resolve, reject) => {
        axios.post(
            Config.backend_aws_server_url + `ReportBug/createComment`,
            data
        ).then((result) => {
            resolve(result);
        }).catch((err) => {
            reject(err);
        });
    });
    }
    deleteBug(id){
        return new Promise((resolve, reject) => {
            axios.delete(
                Config.backend_aws_server_url + `ReportBug/delete?ROWID=${id}`
            ).then((result) => {
                resolve(result);
            }).catch((err) => {
                reject(err);
            });
        });
    }
    updateBug(data){
        return new Promise((resolve, reject) => {
            axios.put(
                Config.backend_aws_server_url + `ReportBug/update`,
                data
            ).then((result) => {
                resolve(result);
            }).catch((err) => {
                reject(err);
            });
        });
    }

    // shareWorkdriveFolderAccess = (folderId,accessToken) =>{
    //     return new Promise((resolve,reject)=>{
    //         let config = {
    //             method: "POST",
    //             url: "https://workdrive.zoho.com/api/v1/permissions",
    //             headers: {
    //                 Authorization: accessToken
    //             },
    //             data: {
    //                 "resource_id": folderId,
    //                 "shared_type": "personal",
    //                 "email_id": Config.DEV_EMAIL,
    //                 "role_id": "5",
    //                 }
    //             };
    //         axios.post(Config.backend_aws_server_url + "zoho/workdrive", { config: config }).then(async response => {
    //             resolve(response)
    //         }).catch(err => {
    //             reject(err)
    //         })
    //     })
    // }
    handleCopyFile = (source, desinationFolderId, token) => {
        return new Promise((resolve, reject) => {
            var config = {
                Type: "Copy",
                data: {
                    attributes: {
                        resource_id: source
                    },
                    type: "files"
                },
                url: "https://www.zohoapis.com/workdrive/api/v1/files/" + desinationFolderId + "/copy",
                method: "POST",
                headers: {
                    'Authorization': token
                }
            };
            axios.post(Config.backend_aws_server_url + "catalyApi/workdrive", { config: config })
                .then(function (response) {
                    resolve(response)
                })
                .catch(function (error) {
                    reject(error);
                });
        })
    }

    renameFolder = (renameValue, folderId, token) =>{
        return new Promise((resolve,reject)=>{
            var config = {
                Type: "Rename",
                data: {
                    attributes: {
                        name: renameValue,
                    },
                    type: "files"
                },
                url: "https://www.zohoapis.com/workdrive/api/v1/files/" + string(folderId),
                method: "PATCH",
                headers: {
                    'Authorization': token
                }
            };
            axios.post(Config.backend_aws_server_url + "catalyApi/workdrive", { config: config }).then(async response => {
                resolve(response)
            }).catch(err => {
                reject(err)
            })
        })
    }
    createWorkdriveFolder = (parentFolderId,folderName,accessToken) =>{
        return new Promise((resolve,reject)=>{
            let config = {
                Type: "Create",
                data: {
                    attributes: {
                        name: folderName,
                        parent_id: parentFolderId
                    },
                    type: "files"
                },
                url: "https://www.zohoapis.com/workdrive/api/v1/files",
                method: "POST",
                headers: {
                    'Authorization': accessToken
                }
            };
            axios.post(Config.backend_aws_server_url + "zoho/workdrive", { config: config }).then(async response => {
                resolve(response)
            }).catch(err => {
                reject(err)
            })
        })
    }
    
    createNewContact = (modalForm, accessToken) =>{
        const contactObj = {
            "Last_Name": modalForm?.lastName,
            "First_Name": modalForm?.firstName,
            "Email": modalForm?.email,
            "Phone": modalForm?.phone,
            "Owner": {
                "id": modalForm?.contactOwner
            },
            "Contact_Type": modalForm?.contactType,
        };
        if (modalForm?.contactType == "Account" && modalForm?.account) {
            contactObj["Account_Name"] = {
                "id": modalForm.account
            };
        }
        return new Promise((resolve, reject) => {
            let config = {
                Type: "Create",
                data: [contactObj],
                url: "https://www.zohoapis.com/crm/v2/Contacts",
                method: "POST",
                headers: {
                    'Authorization': accessToken
                }
            };
            axios.post(Config.backend_aws_server_url + "zoho/workdrive", { config: config })
            .then(async function (response) {
                resolve(response);
            }).catch(err=>{
                reject(err)
            })
            
        })
    }
    
    addAccountToContact = (contactId, accountId, accessToken) =>{debugger
        return new Promise((resolve, reject) => {
            let config = {
                Type: "Update",
                data: [{
                        "id": contactId,
                        "Contact_Type": "Account",
                        "Account_Name": {
                            "id": accountId
                        }
                }],
                url: "https://www.zohoapis.com/crm/v2/Contacts",
                method: "PUT",
                headers: {
                    'Authorization': accessToken
                }
            };
            axios.post(Config.backend_aws_server_url + "zoho/workdrive", { config: config })
            .then(async function (response) {
                resolve(response);
            }).catch(err=>{
                reject(err)
            })
            
        })
    }
    async ensureFolderPathExists(parentFolderId, folderNames, accessToken) {
        try {
            let currentFolderId = parentFolderId;
    
            for (const folderName of folderNames) {
                const folderResponse = await this.fetchWorkdriveFolderById(currentFolderId, accessToken);
                // 
                const subFolders = folderResponse?.data?.data || [];
    
                const existingFolder = subFolders.find(
                    (item) => {
                        if(item.attributes.name === folderName && item.type === "files"){
                            return item;
                        }
                    }
                );
    
                if (existingFolder) {
                    currentFolderId = existingFolder.id; 
                } else {
                    const createResponse = await this.createWorkdriveFolder(currentFolderId, folderName, accessToken);
                    const createdFolder = createResponse?.data?.data; 
                    if (!createdFolder) {
                        throw new Error(`Failed to create folder: ${folderName}`);
                    }
                    currentFolderId = createdFolder.id; 
                }
            }
            return currentFolderId;
        } catch (error) {
            throw error;
        }
    }
    UploadFileWorkDrive = async (fileObj, parentFolderId,token) => {
        let base64 = await convertToBase64(fileObj);
        return new Promise((resolve, reject) => {
            if (parentFolderId) {
                var config = {
                    Type: "Upload",
                    data: {
                        filename: fileObj.name,
                        content: base64,
                        parent_id: parentFolderId,
                    },
                    url: "https://www.zohoapis.com/workdrive/api/v1/upload",
                    method: "POST",
                    headers: {
                        'Authorization': token
                    }
                };
                // catalyst workdrive ui is used hear
                axios.post(Config.backend_aws_server_url + "catalyApi/workdrive", { config: config })
                .then(async function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
            }
        })
    }
    DownloadFileWorkDrive = async (file_id,token) => { 
        return new Promise((resolve, reject) => {
            if (file_id) {
                var config = { 
                    url: `https://download.zoho.com/v1/workdrive/download/${file_id}`,
                    Type: "Get",
                    headers: {
                        'Authorization': token
                    } 
                };
                // catalyst workdrive ui is used hear
                axios.post(Config.backend_aws_server_url + "catalyApi/workdrive", { config: config })
                .then(async function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
            }
        })
    }
    CopyFileWorkDrive = async (files, parentFolderId,token) => {
        // let base64 = await convertToBase64(fileObj);
        return new Promise((resolve, reject) => {
            if (parentFolderId) {
                var config = {
                    Type: "Copy",
                    data: files ,
                    url: `https://www.zohoapis.com/workdrive/api/v1/files/${parentFolderId}/copy`,
                    method: "POST",
                    headers: {
                        'Authorization': token
                    }
                };
                axios.post(Config.backend_aws_server_url + "zoho/workdrive", { config: config })
                .then(async function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
            }
        })
    }
    handleRenameFolder = (data, token) => {
        return new Promise((resolve, reject) => {
            axios.post(Config.backend_aws_server_url + 'catalyApi/archiveFile',
            {
                file_id: data.id,
                file_name: data.renameValue,
                accessToken: token
            }).then(res => {
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })

    }
    CrudServiceHandler({method,data,route}){
        route = this.URLCONST[route];
        if(method=="GET" && route){
            return new Promise((resolve, reject) => {
                axios.get(Config.backend_aws_server_url + route +"/get",{data:data}).then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        }else if(method=="GETWHERE" && route && data){
            return new Promise((resolve, reject) => {
                axios.post(Config.backend_aws_server_url + route +"/getwhere",{data:data}).then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        }else if(method=="POST" && route){
            data["CREATEDBY"] = localStorage.getItem("ZUID");
            return new Promise((resolve, reject) => {
                axios.post(Config.backend_aws_server_url + route +"/post",{data:data}).then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        }else if(method=="DELETE" && route && data){
            // data["CREATEDBY"] = localStorage.getItem("ZUID");
            return new Promise((resolve, reject) => {
                axios.delete(Config.backend_aws_server_url + route +`/delete?ROWID=${data.ROWID}`).then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        }else if(method=="MULTIDELETE" && route && data){
            // data["CREATEDBY"] = localStorage.getItem("ZUID");
            return new Promise((resolve, reject) => {
                axios.post(Config.backend_aws_server_url + route +"/multidelete",{data:data}).then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        }else if(method=="DELETEBYCOLUMN" && route && data){
            // data["CREATEDBY"] = localStorage.getItem("ZUID");
            return new Promise((resolve, reject) => {
                axios.post(Config.backend_aws_server_url + route +"/delete",{data:data}).then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        }else if(method=="PUT" && route && data){
            data["MODIFIEDBY"] = localStorage.getItem("ZUID");
            return new Promise((resolve, reject) => {
                axios.put(Config.backend_aws_server_url + route +`/update`,{data:data}).then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        }
    }
    createFlowEmailTemplate(data){
        return new Promise((resolve, reject) => {
            axios.post(Config.backend_aws_server_url +`createFlowEmailTemplate`,{data:data}).then(res => {
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    }
    updateFlowEmailTemplate(data){
        return new Promise((resolve, reject) => {
            axios.put(Config.backend_aws_server_url +`updateFlowEmailTemplate`,{data:data}).then(res => {
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    }
    deleteFlowEmailTemplate(ROWID){
        return new Promise((resolve, reject) => {
            axios.delete(Config.backend_aws_server_url +`deleteFlowEmailTemplate?ROWID=${ROWID}`).then(res => {
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    }
    getEmailTemplatesById(id){
        return new Promise((resolve, reject) => {
            axios.get(Config.backend_aws_server_url +`getEmailTemplatesById?flowID=${id}`).then(res => {
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    }
    getAllEmailTemplates(){
        return new Promise((resolve, reject) => {
            axios.get(Config.backend_aws_server_url +`getAllEmailTemplates`).then(res => {
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    }
    attachEmailToTrasition(data){
        return new Promise((resolve, reject) => {
            axios.post(Config.backend_aws_server_url +`attachEmailToTrasition`,{data:data}).then(res => {
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    }
    updateTransitionEmail(data){
        return new Promise((resolve, reject) => {
            axios.put(Config.backend_aws_server_url +`updateTransitionEmail`,{data:data}).then(res => {
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    }
    deleteTransitionEmail(ROWID){
        return new Promise((resolve, reject) => {
            axios.delete(Config.backend_aws_server_url +`deleteTransitionEmail?ROWID=${ROWID}`).then(res => {
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    }
    getTransitionEmailById(flowId,id){
        return new Promise((resolve, reject) => {
            axios.get(Config.backend_aws_server_url +`getTransitionEmailById?TaskFlowId=${flowId}&TransitionEdgeId=${id}`).then(res => {
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    }
    getTransitionEmailByIdParam(flowId){
        return new Promise((resolve, reject) => {
            axios.get(Config.backend_aws_server_url +`getTransitionEmailByIdParam?TaskFlowId=${flowId}`).then(res => {
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    }
    getPipelinesByDeal(Deal){
        return new Promise((resolve, reject) => {
            axios.get(Config.backend_aws_server_url +`getPipelinesByDeal?DealName=${Deal}`).then(res => {
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    }
    attachDealWithSelectedPipelines(deal,rowid,Position,flag,arry,pipelineName){
        return new Promise((resolve, reject) => {
            axios.post(Config.backend_aws_server_url +`attachDealWithSelectedPipelines?Deal=${deal}&ROWID=${rowid}&Position=${Position}&flag=${flag}&dataarray=${arry}&PipelineName=${pipelineName}`).then(res => {
                resolve(res.data)
            }).catch(err => {
                reject(err)
            })
        })
    }
    attachDealWithSelectedPipelinesInternalData(deal,arry,data){
        return new Promise((resolve, reject) => {
            axios.post(Config.backend_aws_server_url +`attachDealWithSelectedPipelinesInternalData?Deal=${deal}&dataarray=${arry}&jsonIds=${data}`).then(res => {
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    }
    removeDealWithSelectedPipelines(deal,rowid,username){
        return new Promise((resolve, reject) => {
            axios.delete(Config.backend_aws_server_url +`removeDealWithSelectedPipelines?Deal=${deal}&ROWID=${rowid}&username=${username}`).then(res => {
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    }
    //Field Update APIs
    CreateUpdateFields(data){
        return new Promise((resolve,reject)=>{
            axios.post(Config.backend_aws_server_url + `CreateUpdateFields`,{data:data}).then(res=>{
                resolve(res)
            }).catch(err=>{
                reject(err)
            })
        })
    }
    DeleteUpdateFields(ids){
        return new Promise((resolve,reject)=>{
            axios.delete(Config.backend_aws_server_url + `DeleteUpdateFields?ROWID=${ids}`).then(res=>{
                resolve(res)
            }).catch(err=>{
                reject(err)
            })
        })
    }
    updateUpdateFields(data){
        return new Promise((resolve,reject)=>{
            axios.put(Config.backend_aws_server_url + `updateUpdateFields`,{data:data}).then(res=>{
                resolve(res)
            }).catch(err=>{
                reject(err)
            })
        })
    }
    getTransitionFieldUpdatesById(flowId,id){
        return new Promise((resolve,reject)=>{
            axios.get(Config.backend_aws_server_url + `getTransitionFieldUpdatesById?TaskFlowId=${flowId}&TransitionEdgeId=${id}`).then(res=>{
                resolve(res)
            }).catch(err=>{
                reject(err)
            })
        })
    }
    CreateEmailAttachmentLink(data){
        return new Promise((resolve,reject)=>{
            axios.post(Config.backend_aws_server_url + `AutomationEmailAttachment/CreateEmailAttachmentLink`,{data:data}).then(res=>{
                resolve(res)
            }).catch(err=>{
                reject(err)
            })
        })
    }
    UpdateEmailAttachmentLink(data){
        return new Promise((resolve,reject)=>{
            axios.post(Config.backend_aws_server_url + `AutomationEmailAttachment/UpdateEmailAttachmentLink`,{data:data}).then(res=>{
                resolve(res)
            }).catch(err=>{
                reject(err)
            })
        })
    }
    DeleteEmailAttachmentLink(ROWID){
        return new Promise((resolve,reject)=>{
            axios.delete(Config.backend_aws_server_url + `AutomationEmailAttachment/DeleteEmailAttachmentLink?ROWID=${ROWID}`).then(res=>{
                resolve(res)
            }).catch(err=>{
                reject(err)
            })
        })
    }
    getEmailAttachmentLink(DealName,TaskID,taskType){
        return new Promise((resolve,reject)=>{
            axios.get(Config.backend_aws_server_url + `AutomationEmailAttachment/getEmailAttachmentLinkById?DealName=${DealName}&TaskROWID=${TaskID}&Type=${taskType}`).then(res=>{
                resolve(res)
            }).catch(err=>{
                reject(err)
            })
        })
    }
    getRelatedDataForTransition(){
        return new Promise((resolve,reject)=>{
            axios.get(Config.backend_aws_server_url + `getRelatedDataForTransition`).then(res=>{
                resolve(res)
            }).catch(err=>{
                reject(err)
            })
        })
    }
    getAllRelatedDataOfTasksWithEmail(){
        return new Promise((resolve,reject)=>{
            axios.get(Config.backend_aws_server_url + `getAllRelatedDataOfTasksWithEmail`).then(res=>{
                resolve(res)
            }).catch(err=>{
                reject(err)
            })
        })
    }
    getMessageIDsForEmailAutomation(rowid,type){
        return new Promise((resolve,reject)=>{
            axios.get(Config.backend_aws_server_url + `emailAutomation/get?TaskROWID=${rowid}&TaskType=${type}`).then(res=>{
                resolve(res)
            }).catch(err=>{
                reject(err)
            })
        })
    }
    getEmailsForEmailAutomation(IDs){
        return new Promise((resolve,reject)=>{
            axios.get(Config.backend_aws_server_url + `emailAutomation/getAutomationEmails?MessageIds=${IDs}`).then(res=>{
                resolve(res)
            }).catch(err=>{
                reject(err)
            })
        })
    }
    getUserByEmail(email){
        return new Promise((resolve,reject)=>{
            axios.get(Config.backend_aws_server_url + `OAuthTokens/getUserByEmail?email=${email}`).then(res=>{
                resolve(res)
            }).catch(err=>{
                reject(err)
            })
        })
    }

    getTaskRelatedComments(taskId, taskType){ 
        return new Promise((resolve,reject)=>{
            axios.get(Config.backend_aws_server_url + 'getTaskRelatedComments',{params: { taskId, taskType }}).then(res=>{
                resolve(res)
            }).catch(err=>{
                reject(err)
            })
        })
    }
    checkIfMilestonePresent(pipelineROWID, selectedTable){
        return new Promise((resolve,reject)=>{
            axios.get(Config.backend_aws_server_url + `checkIfMilestonePresent?PipelineROWID=${pipelineROWID}&selectedTable=${selectedTable}`).then(res=>{
                resolve(res)
            }).catch(err=>{
                reject(err)
            })
        })
    }
    updateTaskIndexInTemplate(rowId, pipelineRowId, from, to){
        return new Promise(async (resolve,reject)=>{
            await axios.put(`${Config.backend_aws_server_url}TaskIndexing/put`, {rowId, pipelineRowId, from, to}).then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err);
            })
        })
    }
    
    updateIndexInTaskList(pipelineROWID, from, to){
        return new Promise(async (resolve,reject)=>{
            await axios.put(`${Config.backend_aws_server_url}TaskListIndexing/put`, {pipelineROWID, from, to}).then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err);
            })
        })
    }
    getAllTaskStatuses(){
        return new Promise(async (resolve,reject)=>{
            await axios.get(`${Config.backend_aws_server_url}TaskAccessControl/getAllTaskStatuses`).then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err);
            })
        })
    }

    getAllTaskLatestActivities(dealNames){
        return new Promise((resolve,reject)=>{
            axios.get(Config.backend_aws_server_url + `getAllTaskLatestActivities?dealNames=${dealNames}`).then(res=>{
                resolve(res)
            }).catch(err=>{
                reject(err)
            })
        })
    }
    getAllTaskComments(dealNames){
        return new Promise((resolve,reject)=>{
            axios.get(Config.backend_aws_server_url + `getAllTaskComments?dealNames=${dealNames}`).then(res=>{
                resolve(res)
            }).catch(err=>{
                reject(err)
            })
        })
    }
    getAllStatusTimeForTask(dealNames){
        return new Promise((resolve,reject)=>{
            axios.get(Config.backend_aws_server_url + `getAllStatusTimeForTask?dealNames=${dealNames}`).then(res=>{
                resolve(res)
            }).catch(err=>{
                reject(err)
            })
        })
    }

    GetApplicationProfiles(){
        return new Promise((resolve, reject)=>{
            axios.get(Config.backend_aws_server_url + `Profiles/All`).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err)
            })
        })
    }

    UpdateProfile(payload){
        return new Promise((resolve, reject) => {
            axios.post(Config.backend_aws_server_url+ 'Profiles/EditProfile',payload)
            .then((result) => {
                resolve(result);
            })
            .catch((err) => {
                reject(err);
            })
        })
    }
    
    UpdateUserProfile(payload){
        return new Promise((resolve, reject) => {
            axios.put(Config.backend_aws_server_url+ 'User/Update',payload)
            .then((result) => {
                resolve(result);
            })
            .catch((err) => {
                reject(err);
            })
        })
    }
    getUserById(EMAIL_ID){
        return new Promise((resolve, reject) => {
            axios.get(Config.backend_aws_server_url+ `User/getUser?EMAIL_ID=${EMAIL_ID}`)
            .then((result) => {
                resolve(result?.data);
            })
            .catch((err) => {
                reject(err);
            })
        })
    }
    updateUserById(payload){
        return new Promise((resolve, reject) => {
            axios.put(Config.backend_aws_server_url+ 'User/updateUser',{data:payload})
            .then((result) => {
                resolve(result);
            })
            .catch((err) => {
                reject(err);
            })
        })
    }
    
    DeleteProfile(payload){
        return new Promise((resolve, reject) => {
            axios.post(Config.backend_aws_server_url+ 'Profiles/DeleteProfile',payload)
            .then((result) => {
                resolve(result);
            })
            .catch((err) => {
                reject(err);
            })
        })
    }
    
    AddProfile(payload){
        return new Promise((resolve, reject) => {
            axios.post(Config.backend_aws_server_url+ 'Profiles/AddProfile',payload)
            .then((result) => {
                resolve(result);
            })
            .catch((err) => {
                reject(err);
            })
        })
    }

    AllModules(){
        return new Promise((resolve, reject) => {
            axios.get(Config.backend_aws_server_url+ `AppModules/All`).then((result) => {
                resolve(result);
            })
            .catch((err) => {
                reject(err)
            })
        })
    }
    
    GetSubModules(){
        return new Promise((resolve, reject) => {
            axios.get(Config.backend_aws_server_url+ `SubModules/GetSubModules`).then((result) => {
                resolve(result);
            })
            .catch((err) => {
                reject(err)
            })
        })
    }
    
    GetProfile(profileId){
        return new Promise((resolve, reject) => {
            axios.get(Config.backend_aws_server_url+ `Profiles/GetProfile/${profileId}`).then((result) => {
                resolve(result);
            })
            .catch((err) => {
                reject(err)
            })
        })
    }
    
    AllFields(){
        return new Promise((resolve, reject) => {
            axios.get(Config.backend_aws_server_url+ `Fields/All`).then((result) => {
                resolve(result);
            })
            .catch((err) => {
                reject(err)
            })
        })
    }
    
    GetUserProfile(emailId){
        return new Promise((resolve, reject) => {
            axios.get(Config.backend_aws_server_url+ `Profiles/UserProfile/${emailId}`).then((result) => {
                resolve(result);
            })
            .catch((err) => {
                reject(err)
            })
        })
    }
    
    fetchTeamFolderData = (teamId, accessToken) =>{
        return new Promise((resolve, reject) => {
            let config = {
                Type: "Get",
                url: "https://www.zohoapis.com/workdrive/api/v1/teams/" + teamId + "/teamfolders",
                method: "GET",
                headers: {
                    'Authorization': accessToken
                }
            };
            axios.post(Config.backend_aws_server_url + "zoho/workdrive", { config: config })
            .then(async function (response) {
                resolve(response);
            }).catch(err=>{
                reject(err)
            })
            
        })
    }

    openFolderData = (folderId, accessToken) =>{debugger
        return new Promise((resolve, reject) => {
            let config = {
                Type: "Get",
                url: "https://www.zohoapis.com/workdrive/api/v1/teamfolders/" + folderId + "/folders",
                method: "GET",
                headers: {
                    'Authorization': accessToken
                }
            };
            axios.post(Config.backend_aws_server_url + "zoho/workdrive", { config: config })
            .then(async function (response) {
                resolve(response);
            }).catch(err=>{
                reject(err)
            })
            
        })
    }
    
    givePermissionToUser = (selectedUsers, roleId, selectedFolderId, accessToken) =>{debugger
        return new Promise((resolve, reject) => {
            let config = {
                Type: "AddPermission",
                data: {
                 "data": {
                    "attributes": {
                        "resource_id": String(selectedFolderId),
                        "shared_type": "personal",
                        "email_id": String(selectedUsers[0]?.email || selectedUsers?.email || selectedUsers?.Email || selectedUsers?.attributes?.email_id),
                        "role_id": String(roleId),
                        // expiration_date: "",
                        "send_notification_mail": "true"
                    },
                    "type": "permissions"
                 }
                },
                url: "https://www.zohoapis.com/workdrive/api/v1/permissions",
                method: "POST",
                headers: {
                    'Authorization': accessToken
                }
            };
            axios.post(Config.backend_aws_server_url + "zoho/workdrive", { config: config })
            .then(async function (response) {
                resolve(response);
            }).catch(err=>{
                reject(err)
            })
            
        })
    }
    
    shareLinkExternally = (folderId, permissionId, linkName, expiryDate, accessToken) =>{debugger
        return new Promise((resolve, reject) => {
            let config = {
                Type: "AddPermission",
                data: {
                 "data": {
                    "attributes": {
                        "resource_id": String(folderId),    
                        "link_name": String(linkName),
                        "request_user_data":"false",
                        "allow_download": "true",
                        "role_id": String(permissionId),
                        "expiration_date": expiryDate.format("YYYY-MM-DD"),
                    },
                    "type": "links"
                }
                },
                url: "https://www.zohoapis.com/workdrive/api/v1/links",
                method: "POST",
                headers: {
                    'Authorization': accessToken
                }
            };
            axios.post(Config.backend_aws_server_url + "zoho/workdrive", { config: config })
            .then(async function (response) {
                resolve(response);
            }).catch(err=>{
                reject(err)
            })
            
        })
    }
    UpdateLinkShareDetails = (selectedLink, linkName, expiryDate, permissionId, accessToken) =>{debugger
        return new Promise((resolve, reject) => {
            let config = {
                Type: "UpdatePermission",
                data: {
                 "data": {
                    "attributes": {  
                        "link_name": String(linkName),
                        "role_id": String(permissionId),
                        "expiration_date": expiryDate.format("YYYY-MM-DD"),
                    },
                    "type": "links"
                }
                },
                url: "https://www.zohoapis.com/workdrive/api/v1/links/"+selectedLink?.id,
                method: "PATCH",
                headers: {
                    'Authorization': accessToken
                }
            };
            axios.post(Config.backend_aws_server_url + "zoho/workdrive", { config: config })
            .then(async function (response) {
                resolve(response);
            }).catch(err=>{
                reject(err)
            })
            
        })
    }
    
    updateMemberRole = (selectedUsers, roleId, accessToken) =>{debugger
        const permissionId = String(selectedUsers?.id) ;
        return new Promise((resolve, reject) => {
            let config = {
                Type: "UpdatePermission",
                data: {
                 "data": {
                    "attributes": {
                        "role_id": String(roleId),
                    },
                    "type": "permissions"
                 }
                },
                url: "https://www.zohoapis.com/workdrive/api/v1/permissions/"+permissionId,
                method: "PATCH",
                headers: {
                    'Authorization': accessToken
                }
            };
            axios.post(Config.backend_aws_server_url + "zoho/workdrive", { config: config })
            .then(async function (response) {
                resolve(response);
            }).catch(err=>{
                reject(err)
            })
            
        })
    }
    
    customizeFolder = (resourceId, isCustomized, accessToken) =>{
        return new Promise((resolve, reject) => {
            let config = {
                Type: "CustomizeFolder",
                data: {
                 "data": {
                    "attributes": {
                        "customized": isCustomized
                    },
                    "type": "files"
                 }
                },
                url: "https://www.zohoapis.com/workdrive/api/v1/files/"+resourceId,
                method: "PATCH",
                headers: {
                    'Authorization': accessToken
                }
            };
            axios.post(Config.backend_aws_server_url + "zoho/workdrive", { config: config })
            .then(async function (response) {
                resolve(response);
            }).catch(err=>{
                reject(err)
            })
            
        })
    }
    
    moveToTrash = (selectedItem, accessToken) =>{
        let config;
        return new Promise((resolve, reject) => {
            if(selectedItem.length > 1){
                config = {
                    Type: "CustomizeFolder",
                    data: {
                        "data": selectedItem.map(item => ({
                            "attributes": {
                                    "status": "51"
                                },
                                "id": item?.id,
                                "type": "files"
                        })),
                    },
                    url: "https://www.zohoapis.com/workdrive/api/v1/files",
                    method: "PATCH",
                    headers: {
                        'Authorization': accessToken
                    }
                };
            } else {
                const folderId = selectedItem?.[0].id;
                config = {
                    Type: "CustomizeFolder",
                    data: {
                        "data": {
                            "attributes": {
                                "status": "51"
                            },
                            "type": "files"
                        }
                    },
                    url: "https://www.zohoapis.com/workdrive/api/v1/files/"+folderId,
                    method: "PATCH",
                    headers: {
                        'Authorization': accessToken
                    }
                };
            }
            axios.post(Config.backend_aws_server_url + "zoho/workdrive", { config: config })
            .then(async function (response) {
                resolve(response);
            }).catch(err=>{
                reject(err)
            })
            
        })
    }
    
    restoreTrash = (selectedItem, accessToken) =>{
        let config;
        return new Promise((resolve, reject) => {
            if(selectedItem.length > 1){
                config = {
                    Type: "CustomizeFolder",
                    data: {
                        "data": selectedItem.map(item => ({
                            "attributes": {
                                    "status": "1"
                                },
                                "id": item?.id,
                                "type": "files"
                        })),
                    },
                    url: "https://www.zohoapis.com/workdrive/api/v1/files",
                    method: "PATCH",
                    headers: {
                        'Authorization': accessToken
                    }
                };
            } else {
                const folderId = selectedItem?.id;
                config = {
                    Type: "CustomizeFolder",
                    data: {
                        "data": {
                            "attributes": {
                                "status": "1"
                            },
                            "type": "files"
                        }
                    },
                    url: "https://www.zohoapis.com/workdrive/api/v1/files/"+folderId,
                    method: "PATCH",
                    headers: {
                        'Authorization': accessToken
                    }
                };
            }
            axios.post(Config.backend_aws_server_url + "zoho/workdrive", { config: config })
            .then(async function (response) {
                resolve(response);
            }).catch(err=>{
                reject(err)
            })
            
        })
    }
    
    revokeSharedLink = (selectedItem, accessToken) =>{
        return new Promise((resolve, reject) => {
            let config = {
                Type: "RemovePermission",
                url: "https://www.zohoapis.com/workdrive/api/v1/links/"+selectedItem?.id,
                method: "DELETE",
                headers: {
                    'Authorization': accessToken
                }
            };
            axios.post(Config.backend_aws_server_url + "zoho/workdrive", { config: config })
            .then(async function (response) {
                resolve(response);
            }).catch(err=>{
                reject(err)
            })
            
        })
    }
    deleteFolderPermanantly = (selectedItem, accessToken) =>{
        let config;
        return new Promise((resolve, reject) => {
            if(selectedItem.length > 1){
                config = {
                    Type: "CustomizeFolder",
                    data: {
                        "data": selectedItem.map(item => ({
                            "attributes": {
                                    "status": "61"
                                },
                                "id": item?.id,
                                "type": "files"
                        })),
                    },
                    url: "https://www.zohoapis.com/workdrive/api/v1/files",
                    method: "PATCH",
                    headers: {
                        'Authorization': accessToken
                    }
                };
            } else {
                const folderId = selectedItem?.id;
                config = {
                    Type: "CustomizeFolder",
                    data: {
                        "data": {
                            "attributes": {
                                "status": "61"
                            },
                            "type": "files"
                        }
                    },
                    url: "https://www.zohoapis.com/workdrive/api/v1/files/"+folderId,
                    method: "PATCH",
                    headers: {
                        'Authorization': accessToken
                    }
                };
            }
            axios.post(Config.backend_aws_server_url + "zoho/workdrive", { config: config })
            .then(async function (response) {
                resolve(response);
            }).catch(err=>{
                reject(err)
            })
            
        })
    }
    
    removePermission = (permissionId, accessToken) =>{debugger
        return new Promise((resolve, reject) => {
            let config = {
                Type: "RemovePermission",
                url: "https://www.zohoapis.com/workdrive/api/v1/permissions/"+permissionId,
                method: "DELETE",
                headers: {
                    'Authorization': accessToken
                }
            };
            axios.post(Config.backend_aws_server_url + "zoho/workdrive", { config: config })
            .then(async function (response) {
                resolve(response);
            }).catch(err=>{
                reject(err)
            })
            
        })
    }
    
    getTrashData = (folderId, accessToken) =>{
        return new Promise((resolve, reject) => {
            let config = {
                Type: "Get",
                url: "https://www.zohoapis.com/workdrive/api/v1/teamfolders/"+folderId+"/trashedfiles",
                method: "GET",
                headers: {
                    'Authorization': accessToken
                }
            };
            axios.post(Config.backend_aws_server_url + "zoho/workdrive", { config: config })
            .then(async function (response) {
                resolve(response);
            }).catch(err=>{
                reject(err)
            })
            
        })
    }
   
    getExternalLinks = (folderId, accessToken) =>{
        return new Promise((resolve, reject) => {
            let config = {
                Type: "Get",
                url: "https://www.zohoapis.com/workdrive/api/v1/files/"+folderId+"/links",
                method: "GET",
                headers: {
                    'Authorization': accessToken
                }
            };
            axios.post(Config.backend_aws_server_url + "zoho/workdrive", { config: config })
            .then(async function (response) {
                resolve(response);
            }).catch(err=>{
                reject(err)
            })
            
        })
    }
    getLinkSharedUsers = (folderId) => {
        return new Promise((resolve, reject) => {
            axios.get(Config.backend_aws_server_url+ `linkShareLogs/getByFolderId/${folderId}`).then((result) => {
                resolve(result);
            })
            .catch((err) => {
                reject(err)
            })
        })
    }
    fetchFolderMembers = (folderId, accessToken) =>{
        return new Promise((resolve, reject) => {
            let config = {
                Type: "Get",
                url: "https://www.zohoapis.com/workdrive/api/v1/files/" + folderId + "/permissions",
                method: "GET",
                headers: {
                    'Authorization': accessToken
                }
            };
            axios.post(Config.backend_aws_server_url + "zoho/workdrive", { config: config })
            .then(async function (response) {
                resolve(response);
            }).catch(err=>{
                reject(err)
            })
            
        })
    }
    
    fetchFolderInfo = (folderId, accessToken) =>{debugger
        return new Promise((resolve, reject) => {
            let config = {
                Type: "Get",
                url: "https://www.zohoapis.com/workdrive/api/v1/files/"+folderId,
                method: "GET",
                headers: {
                    'Authorization': accessToken
                }
            };
            axios.post(Config.backend_aws_server_url + "zoho/workdrive", { config: config })
            .then(async function (response) {
                resolve(response);
            }).catch(err=>{
                reject(err)
            })
            
        })
    }

    AddUserToLink(payload){
        return new Promise(async (resolve,reject)=>{
            await axios.post(`${Config.backend_aws_server_url}linkShareLogs/post`, payload).then(res=>{
                resolve(res.data[0]);
            }).catch(err=>{
                reject(err);
            })
        })
    }
    AddUser(payload){
        return new Promise((resolve, reject) => {
            axios.post(Config.backend_aws_server_url+ 'User/Add',payload)
            .then((result) => {
                resolve(result);
            })
            .catch((err) => {
                reject(err);
            })
        })
    }
    fetchLocalUsers(){
        return new Promise((resolve, reject) => {
            axios.get(Config.backend_aws_server_url+ `User/All`).then((result)=>{
              resolve(result);  
            }).catch((err) => {
                reject(err);
            })
        })
    }

    UpdateUser(payload){
        return new Promise((resolve, reject) => {
            axios.put(Config.backend_aws_server_url+ 'User/Update',payload)
            .then((result) => {
                resolve(result);
            })
            .catch((err) => {
                reject(err);
            })
        })
    }
    
    fechUserByzuid(zuid) {
        return new Promise((resolve, reject) => {
            axios.get(Config.backend_aws_server_url + `User/Get?zuid=${zuid}`)
            .then((result) => {
            resolve(result.data);
            })
            .catch((err) => {
            reject(err);
            });
        });
    }

    // createFolderByDir = async (homeDirId, pathArray, accessToken) => {
    //     let folderNameToCheck = pathArray[0];
    //     await this.fetchWorkdriveFolderById(homeDirId,accessToken).then(folders=>{
    //         let subFolder = folders?.find(folder=>(
    //             folder.attributes.type == "folder" && folder.attributes.name == folderNameToCheck
    //         ));
    //         if(subFolder){

    //         }else{
    //             this.createWorkdriveFolder(homeDirId,folderNameToCheck).then(createdFolder=>{
    //                 return createFolderByDir()
    //             })
    //         }
    //     })
    //     // let config = {
    //     //     Type: "Get",
    //     //     url: "https://www.zohoapis.com/workdrive/api/v1/files/" + homeDirId + "/files",
    //     //     method: "GET",
    //     //     headers: {
    //     //         'Authorization': accessToken
    //     //     }
    //     // };
    //     //await axios.post(Config.backend_url + "workdrive", { config: config })
    //         // .then(async function (response) {
    //         //     let responseData = response.data.data;
    //         //     let isFolderExist = responseData.some(folder=>(
    //         //         folder.attributes.type == 'folder' && folder.attributes.name == 'Documents'
    //         //     ));

    //         //     for (let index = 0; index < responseData?.length; index++) {
    //         //         if (responseData[index].attributes.type == 'folder' && responseData[index].attributes.name == 'Documents') {
    //         //             isFolderExist = true;
    //         //         }
    //         //     }
    //         //     if (props.data.zohoworkdriveforcrm__Workdrive_Folder_ID == parent_id && parent_id == folderId && !isFolderExist) {
    //         //         var config = {
    //         //             Type: "Create",
    //         //             data: {
    //         //                 attributes: {
    //         //                     name: "Documents",
    //         //                     parent_id: folderId
    //         //                 },
    //         //                 type: "files"
    //         //             },
    //         //             url: "https://www.zohoapis.com/workdrive/api/v1/files",
    //         //             method: "POST",
    //         //             headers: {
    //         //                 'Authorization': token
    //         //             }
    //         //         };
    //         //         await axios.post(backendUrl + "workdrive", { config: config }).then(async res => {
    //         //             let resData = res.data.data;
    //         //             responseData = responseData.concat(resData)
    //         //             var config = {
    //         //                 Type: "Create",
    //         //                 data: {
    //         //                     attributes: {
    //         //                         name: "Task",
    //         //                         parent_id: resData.id
    //         //                     },
    //         //                     type: "files"
    //         //                 },
    //         //                 url: "https://www.zohoapis.com/workdrive/api/v1/files",
    //         //                 method: "POST",
    //         //                 headers: {
    //         //                     'Authorization': token
    //         //                 }
    //         //             };
    //         //             await axios.post(backendUrl + "workdrive", { config: config }).then(async rData => {
    //         //                 let relativePath = rData.data.data.id;
    //         //                 let DealName = props.data.Deal_Name;
    //         //                 let module = props.module;
    //         //                 await AwsServerService.saveRelativePath({ DealName: DealName, Module: module, RelativePath: relativePath }).then(r => {
    //         //                     props.setRelativePathId(relativePath);
    //         //                 }).catch(er => {
    //         //                     console.log(er);
    //         //                 })
    //         //                 setLoaderState(false);
    //         //                 setSelectedFiles(responseData);
    //         //             }).catch(err => {
    //         //                 setLoaderState(false);
    //         //                 setSelectedFiles(response.data.data)
    //         //             })
    //         //         }).catch(err => {
                        
    //         //         })
    //         //     }
              
    //         // })
    //         // .catch(function (error) {
               
    //         //     console.log(error);
    //         // });

    // }
}

export default new AWSService();